export const sceneVoxels = `
    float getMapHeight(vec2 p) {
        float h = noise(p * 0.1) * 2.0 + noise(p * 0.3) * 0.5;
        return floor(h * 4.0) / 4.0;
    }
    vec3 sceneVoxels(vec3 rd, float time) {
        vec3 ro = vec3(0.0, 2.5, time * 4.0); rd.yz *= rot(0.3);
        float t = 0.0; vec3 col = mix(vec3(0.4, 0.6, 1.0), vec3(0.0, 0.1, 0.3), rd.y * 0.5 + 0.5);
        for(int i=0; i<64; i++) {
            vec3 p = ro + rd * t; float h = getMapHeight(p.xz);
            if (p.y < h) {
                vec3 matCol = vec3(0.5);
                if (h < -0.5) matCol = vec3(0.1, 0.3, 0.8); else if (h < 0.0) matCol = vec3(0.9, 0.8, 0.4);
                else if (h < 1.0) matCol = vec3(0.1, 0.6, 0.1); else if (h < 1.8) matCol = vec3(0.5, 0.5, 0.5);
                else matCol = vec3(0.9, 0.9, 1.0);
                if (h >= 0.0 && h < 1.0 && hash(floor(p.xz * 2.0)) > 0.9) matCol = vec3(0.05, 0.3, 0.05);
                col = matCol * (dot(normalize(vec3(h-getMapHeight(p.xz+vec2(.1,0.)),1.,h-getMapHeight(p.xz+vec2(0.,.1)))), normalize(vec3(-.5,.8,-.5)))*.5+.5);
                col = mix(col, col*0.5+vec3(0.4,0.6,1.0)*0.5, 1.0-exp(-t*0.03)); break;
            }
            t += 0.1 + t * 0.03; if(t > 80.0) break;
        }
        return col;
    }
`;
